<div class="time-picker-container" [style.background-color]="backgroundColor" [style.width]="width + 'px'">
  <div class="grid grid-cols-12">
<!--    <div class="flex">-->
<!--      <p class="justify-center text-primary font-bold mx-5">Hour</p>-->
<!--      <p class="justify-center text-primary font-bold mx-4">Minutes</p>-->
<!--    </div>-->
    <ul class="col-span-6 pr-0 time-unit-card time-picker-list no-select"
        [ngClass]="{'disable-scroll-animation': !enableAnimation}" #hoursList>
      <cdk-virtual-scroll-viewport #hoursViewPort [itemSize]="unitHeight" class="viewport">
        <li class="time-unit p-2 flex justify-center" *cdkVirtualFor="let hour of hours; let i = index"
            [ngClass]="{'active': selectedHour === hour}"
            [attr.id]="hour"
            [style.color]="this.textColor"
            [style.background-color]="selectedHour === hour ? this.primaryColor : 'unset'"
            (click)="setHours(hour)">{{hour}}</li>
      </cdk-virtual-scroll-viewport>
    </ul>

    <ul class="col-span-6 time-unit-card pl-0 time-picker-list no-select"
        [ngClass]="{'disable-scroll-animation': !enableAnimation}" #minutesList>
      <cdk-virtual-scroll-viewport #minutesViewPort [itemSize]="unitHeight" class="viewport">
        <li class="time-unit p-2 flex justify-center" *cdkVirtualFor="let minute of minutes; let i = index"
            [ngClass]="{'active': selectedMinute === minute}"
            [style.color]="this.textColor"
            [style.background-color]="selectedMinute === minute ? this.primaryColor : 'unset'"
            (click)="setMinutes(minute)">{{minute}}</li>
      </cdk-virtual-scroll-viewport>
    </ul>
  </div>
  <div class="!bg-primary flex flex-col justify-center items-center">
    <div class="form p-4 col-12 flex justify-center" *ngIf="manualInput">
      <input type="number" readonly class="d-inline-flex form-control text-center px-0"
             hours
             [max]="maxHours"
             [min]="minHours"
             [style.border-bottom-color]="this.primaryColor"
             [style.background-color]="this.inputControlBackgroundColor"
             [style.color]="this.textColor"
             [style.width]="hoursInputWidth"
             (focus)="hoursInput.select()"
             #hoursInput
             [value]="selectedHour">
      <input type="text" class="d-inline-flex form-control text-center" value=":" readonly disabled
             [style.color]="this.textColor">
      <input type="number" readonly class="d-inline-flex form-control text-center px-0" minutes
             [max]="maxMinutes"
             [min]="minMinutes"
             [style.border-bottom-color]="this.primaryColor"
             [style.background-color]="this.inputControlBackgroundColor"
             [style.color]="this.textColor"
             (focus)="minutesInput.select()"
             #minutesInput
             [value]="selectedMinute">
    </div>
    <div class="px-4 pb-4">
      <div class="flex items-center">
        <button type="button" (click)="resetDateInput()"
                class=" mx-2 text-white bg-red-700 hover:bg-red-800 font-medium rounded-lg text-sm p-1.5 text-center inline-flex items-center mr-2">
          <svg class="h-4 w-4 text-white"  fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>

        <div>
          <button type="button" class="btn btn-primary" (click)="pickedTimeBtnClicked()"
                  style="font-size: 1rem"
                  [disabled]="isDisable"
                  [style.background-color]="this.primaryColor"
                  [style.border-color]="this.primaryColor">{{pickTimeText}}
          </button>
        </div>

      </div>

    </div>
  </div>
</div>
